import { combineReducers } from "@reduxjs/toolkit";
import type { HotelsAvailabilityState } from "../features/availability/store";
import hotelsAvailabilityReducer from "../features/availability/store/slice";
import { hotelsPostBookingApi } from "../features/postBooking/store/";
import hotelsShopReducer from "../features/shop/store/slice";
import type { HotelsShopState } from "../features/shop/store/types";
import { createHotelUrlMiddleware } from "./urlMiddleWare";

export interface HotelsState {
  hotels: {
    hotelsAvailability: HotelsAvailabilityState;
    hotelsShop: HotelsShopState;
  };
}

export const hotelsRootReducer = combineReducers({
  hotelsAvailability: hotelsAvailabilityReducer,
  hotelsShop: hotelsShopReducer,
});

export const hotelReducers = {
  hotels: hotelsRootReducer,
  [hotelsPostBookingApi.reducerPath]: hotelsPostBookingApi.reducer,
};

export const hotelMiddlewares = [
  hotelsPostBookingApi.middleware,
  createHotelUrlMiddleware(),
];

export { hotelsPostBookingApi };
